export interface BaseModel<T> {
  toJSON(): T;
}

export interface BaseItemData {
  id: string;
  name?: string;
  createdAt?: string;
  modifiedAt?: string;
}

export enum ItemType {
  REPORT = 'report',
  FOLDER = 'folder',
  BATCH = 'batch'
}

export interface DisplayableItem extends BaseItemData {
  type: ItemType;
}